function initHeaderSubmenu() {
  document.querySelectorAll('.header__submenu__nav').forEach((nav) => {
    if (!nav) return;

    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', () => initHeaderSubmenu(), { once: true });
      return;
    }

    const swiper = new Swiper(nav, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: true,
      // slidesOffsetBefore: 8, 
      // slidesOffsetAfter: 14, 
      watchOverflow: true,
      simulateTouch: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
    });

    const activeItem = nav.querySelector('.header__submenu__link--active');
    if (activeItem) {
      const item = activeItem.parentElement; // the <li>
      const index = Array.from(item.parentElement.children).indexOf(item);
      if (index > -1) {
        swiper.slideTo(index, 0);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initHeaderSubmenu);
document.addEventListener('shopify:section:load', initHeaderSubmenu);
